import React from "react";
import { observer } from "mobx-react";
import { Input, Stack, InputGroup, InputLeftElement } from "@chakra-ui/react";
import { SearchIcon } from "@chakra-ui/icons";

type Props = {
  placeholder: string;
  value: string;
  onChange: (value: string) => void;
};

export const SearchBar: React.FC<Props> = observer(
  ({ placeholder, value = "", onChange }) => {
    return (
      <Stack spacing={4}>
        <InputGroup>
          <InputLeftElement
            pointerEvents="none"
            children={<SearchIcon color="gray.300" />}
          />
          <Input
            variant="flushed"
            placeholder={placeholder}
            value={value}
            onChange={(event) => onChange(event.target.value)}
          />
        </InputGroup>
      </Stack>
    );
  }
);
